import type { Environments } from '@/types';
import request from '@/utils/request';

export const ENVIRONMENTS_URL = '/api/v1/environments/';

export const getEnvironments = async (): Promise<Environments> => {
  return (await request.get<Environments>(ENVIRONMENTS_URL)).data;
};
